export type ClassValue = string | false | null | undefined;

/**
 * Joins class names, dropping falsy entries so conditional classes read as
 * `isActive && 'bg-surface-raised'` inline.
 *
 * Deliberately not clsx + tailwind-merge. Every component below picks its
 * classes through a variant record rather than by concatenating competing
 * utilities, so there is nothing for a merge step to resolve.
 */
export function cx(...values: ClassValue[]): string {
  let out = '';
  for (const value of values) {
    if (!value) continue;
    out = out === '' ? value : `${out} ${value}`;
  }
  return out;
}
